import { z } from 'zod';

import { contentSchema } from '../content';
import { ContentAiFunnelStatus, contentFunnelSchema } from '../content-funnel';

//////////////////////////
// AI Create Funnel
export const createFunnelReqSchema = z.object({
  params: z.object({
    id: contentSchema.shape._id,
  }),
  query: z.object({}).nullish(),
  body: z.object({}).nullish(),
});
export type CreateFunnelReq = z.infer<typeof createFunnelReqSchema>;
export const createFunnelResSchema = {
  200: z.object({
    contentFunnel: contentFunnelSchema.strip(),
  }),
};
export type CreateFunnelRes = z.infer<(typeof createFunnelResSchema)[200]>;

//////////////////////////
// AI Funnel
export const moveFunnelReqSchema = z.object({
  params: z.object({
    id: contentSchema.shape._id,
  }),
  query: z.object({}).nullish(),
  body: z.object({
    toStep: z.enum([
      ContentAiFunnelStatus.Brief,
      ContentAiFunnelStatus.ReqGenTitles,
      ContentAiFunnelStatus.ReqGenOutlines,
      ContentAiFunnelStatus.ReqGenContent,
    ]),
    title: z.string().trim().min(1).nullish(),
    outline: contentFunnelSchema.shape.selectedOutline.nullish(),
    voice: contentFunnelSchema.shape.selectedVoice.nullish(),
  }),
});
export type MoveFunnelReq = z.infer<typeof moveFunnelReqSchema>;

export const moveFunnelResSchema = {
  200: z.object({
    ok: z.boolean(),
  }),
};
export type MoveFunnelRes = z.infer<(typeof moveFunnelResSchema)[200]>;

//////////////////////////
// AI Retry Funnel
export const retryFunnelReqSchema = z.object({
  params: z.object({
    id: contentSchema.shape._id,
  }),
  query: z.object({}).nullish(),
  body: z.object({}).nullish(),
});
export type RetryFunnelReq = z.infer<typeof retryFunnelReqSchema>;

export const retryFunnelResSchema = {
  200: z.object({
    ok: z.boolean(),
  }),
};
export type RetryFunnelRes = z.infer<(typeof retryFunnelResSchema)[200]>;

//////////////////////////
// AI Recheck
export const recheckReqSchema = z.object({
  params: z.object({
    id: contentSchema.shape._id,
  }),
  query: z.object({}).nullish(),
  body: z.object({}).nullish(),
});
export type RecheckReq = z.infer<typeof recheckReqSchema>;

export const recheckResSchema = {
  200: z.object({
    ok: z.boolean(),
  }),
};
export type RecheckRes = z.infer<(typeof recheckResSchema)[200]>;

//////////////////////////
// AI Save funnel
export const saveFunnelReqSchema = z.object({
  params: z.object({
    id: contentSchema.shape._id,
  }),
  query: z.object({}).nullish(),
  body: z.object({
    contentFunnelData: z
      .object({
        selectedTitle: contentFunnelSchema.shape.selectedTitle,
        selectedOutline: contentFunnelSchema.shape.selectedOutline,
        selectedVoice: contentFunnelSchema.shape.selectedVoice,
        selectedMetaTitle: contentFunnelSchema.shape.selectedMetaTitle,
        customizedAiTitles: contentFunnelSchema.shape.customizedAiTitles,

        contentType: contentFunnelSchema.shape.contentType,
        talkAboutBrandInIntro: contentFunnelSchema.shape.talkAboutBrandInIntro,
        talkAboutBrandInBody: contentFunnelSchema.shape.talkAboutBrandInBody,
        talkAboutBrandInConclusion: contentFunnelSchema.shape.talkAboutBrandInConclusion,
        supportingMaterials: contentFunnelSchema.shape.supportingMaterials,
        customWordCount: contentFunnelSchema.shape.customWordCount,
        customWordCountValue: contentFunnelSchema.shape.customWordCountValue,
      })
      .partial()
      .strip(),
    startNextStepGeneration: z.boolean().default(false),
  }),
});
export type SaveFunnelReq = z.infer<typeof saveFunnelReqSchema>;

export const saveFunnelResSchema = {
  200: z.object({
    data: contentFunnelSchema.strip(),
  }),
};
export type SaveFunnelRes = z.infer<(typeof saveFunnelResSchema)[200]>;
